import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styles from "@/styles/Gradients.module.css";
import Nav from "react-bootstrap/Nav";
import Logout from "@/components/Logout";
import PortalButton from "@/components/PortalButton";

export default function Layout() {
  const location = useLocation();
  
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);
  
  // Manage body classes based on route depth for scrollbar control
  useEffect(() => {
    const path = location.pathname;
    
    // Remove any existing scroll classes
    document.body.classList.remove('hub-page', 'hub-direct-link', 'deep-page');
    
    // Determine page type and apply appropriate class
    if (path === '/admin' || path === '/admin/') {
      // Hub page - no scrollbars
      document.body.classList.add('hub-page');
    } else if (
      path.match(/^\/admin\/(surveyManager|monitoring|reportsManager|configManager|test-welcome|simple-test|logout)$/) ||
      path.match(/^\/admin\/(users|reports|monitoring|surveyMaker)$/)
    ) {
      // Direct hub links - no scrollbars
      document.body.classList.add('hub-direct-link');
    } else if (
      path.match(/^\/admin\/(users|reports|monitoring|surveyMaker)\//) ||
      path.includes('/admin/') && path.split('/').length > 3
    ) {
      // Deep pages - allow scrollbars
      document.body.classList.add('deep-page');
    }
    
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('hub-page', 'hub-direct-link', 'deep-page');
    };
  }, [location.pathname]);
  
  // const user = null; // null = logged out, object = logged in

  return (
    <div>
      {/* Header and Navigation */}
      <div
        className={`width-100 ${styles.hero} width-p-2 mb-4`}
        style={{ 
          width: "100%", 
          height: "12rem", 
          position: "relative",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {/* Left column: Logo + Home button */}
        <div style={{
          position: "absolute",
          left: "2rem",
          top: "3rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "0.5rem",
          zIndex: 1
        }}>
          {/* Logo */}
          <img 
            src="/images/HUK-Secondary-logo.png"
            alt="Hospice UK Logo" 
            style={{ 
              width: "auto", 
              height: "4rem"
            }} 
          />
          
          {/* Home button under logo */}
          <a 
            href="https://www.hospiceuk.org/" 
            className="nav-btn"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: "1.7rem",
              position: "absolute",
              top: "6.2rem",
              left: 0,
              color: "white",
              textDecoration: "none"
            }}
          >
            Home (Hospice UK)
          </a>
        </div>

        {/* Member Portal text - centered over entire navbar */}
        <h1 style={{ 
          color: "white", 
          fontSize: "2.5rem",
          margin: 0,
          textAlign: "center",
          border: "2px solid white",
          borderRadius: "15px",
          padding: "0.5rem 1rem",
          display: "inline-block",
          whiteSpace: "nowrap",
          position: "absolute",
          left: "50%",
          top: "45%",
          transform: "translate(-50%, -50%)",
          zIndex: 2
        }}>
          ADMIN PORTAL
        </h1>

        {/* Bottom right: Navigation links */}
        <nav className="nav-buttons" style={{
          position: "absolute",
          bottom: "0.5rem", /* Moved closer to bottom */
          right: "2rem",
          zIndex: 10 // Ensure nav items are above the title
        }}>
         
          <Nav.Item style={{ display: "flex", alignItems: "center" }}>
            <PortalButton />
          </Nav.Item>
          <Nav.Item style={{ display: "flex", alignItems: "center" }}>
            <Logout />
          </Nav.Item>
        </nav>
       </div>

      {/* Main content */}
      <main style={{ paddingRight: "2rem" }}>
        <Outlet />
      </main>
    </div>
  );
}
